module.exports = __webpack_public_path__ + "static/media/44.241e7e30.JPG";